import(/* webpackMode: "eager" */ "C:\\react\\lakeeshop\\src\\app\\not-found.tsx");
